module.exports = __webpack_public_path__ + "img/p002.7f1728ca.png";